import { container, singleton } from 'tsyringe';
import { AxiosHttp, Http, HttpStateCodeHandler, QueryStringObject } from '@/Http';
import { BusinessResult } from '@/Domain';
import { 提示Service, 提示ServiceInjectToken } from '@/Services';

@singleton()
export class LoginClient {
    private readonly _baseUrl: string;

    constructor(baseUrl: string) {
        this._baseUrl = baseUrl;
    }

    private _http: Http<BusinessResult<unknown>> = new AxiosHttp<BusinessResult<unknown>>(
        {
            withCredentials: true,
        },
        undefined,
        [HttpStateCodeHandler]
    );

    get<T>(url: string, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve) => {
            const promise = this._http.get(this.getFullUrl(url), query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve));
        });
    }

    post<T>(url: string, data?: unknown, query?: QueryStringObject): Promise<T> {
        return new Promise((resolve) => {
            const promise = this._http.post(this.getFullUrl(url), data, query) as Promise<BusinessResult<T>>;
            promise.then(this.BusinessErrorFilter(resolve));
        });
    }

    private BusinessErrorFilter<T>(resolve: (value: PromiseLike<T> | T) => void) {
        return (res: BusinessResult<T>) => {
            switch (res.state) {
                case 'Failed': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(res.description);
                    break;
                }
                case 'Fatal': {
                    const notifyService = container.resolve<提示Service>(提示ServiceInjectToken);
                    notifyService.提示错误(`系统错误：${res.description}`);
                    break;
                }
                default:
                    resolve(res.data);
            }
        };
    }

    private getFullUrl(url: string) {
        return this._baseUrl + url;
    }
}
